import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  createFaq,
  deleteFaqById,
  fetchFaqs,
  updateFaq,
} from "../../redux/slices";
import Toast from "../../Hooks/useToast";

const useFaqController = () => {
  const dispatch = useDispatch();
  const { list, loading, saving, deleting } = useSelector((state) => state.faq);

  useEffect(() => {
    dispatch(fetchFaqs());
  }, [dispatch]);

  const refetchFaqs = useCallback(() => {
    dispatch(fetchFaqs());
  }, [dispatch]);

  const handleCreateFaq = async (payload) => {
    try {
      await dispatch(createFaq(payload)).unwrap();
      Toast("FAQ added successfully", "success");
      dispatch(fetchFaqs());
    } catch (err) {
      const msg =
        err?.body?.message ??
        err?.data?.message ??
        err?.message ??
        "Failed to add FAQ";
      Toast(msg, "error");
      throw err;
    }
  };

  const handleUpdateFaq = async (id, payload) => {
    try {
      await dispatch(updateFaq({ id, ...payload })).unwrap();
      Toast("FAQ updated successfully", "success");
      dispatch(fetchFaqs());
    } catch (err) {
      const msg =
        err?.body?.message ??
        err?.data?.message ??
        err?.message ??
        "Failed to update FAQ";
      Toast(msg, "error");
      throw err;
    }
  };

  const handleDeleteFaq = async (id) => {
    try {
      await dispatch(deleteFaqById(id)).unwrap();
      Toast("FAQ deleted successfully", "success");
    } catch (err) {
      const msg =
        err?.body?.message ??
        err?.data?.message ??
        err?.message ??
        "Failed to delete FAQ";
      Toast(msg, "error");
      throw err;
    }
  };

  return {
    values: {
      list,
      loading,
      saving,
      deleting,
    },
    functions: {
      handleCreateFaq,
      handleUpdateFaq,
      handleDeleteFaq,
      refetchFaqs,
    },
  };
};

export default useFaqController;
